module.exports = __webpack_public_path__ + "static/media/add-mobile-icon.de68f326.svg";